import { render } from "./UserAuth.vue?vue&type=template&id=546ae6ce&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=546ae6ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-546ae6ce"

export default script